export default __webpack_public_path__ + "62d2f400c28f96829325c12669681570.png";